import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const statBranchWithEmployeeLocaleModule: LocaleModule = {
  name: "statBranchWithEmployee",
  messages: { en: en, it: it },
};
